import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import "../styles/About.css";
import COLORS from "../styles/colors";
import { FaBullseye , FaGlobe , FaRegHeart, FaLightbulb , FaBolt} from "react-icons/fa";

export default function About() {
    return (
        <div className="about-container">
            {/* hero section*/}
            <div
                className="container d-flex flex-column align-items-center justify-content-start"
                style={{ marginTop: "60px", textAlign: "center", marginBottom: "20px" }}
            >
                <h1
                    style={{
                        fontSize: "36px",
                        fontWeight: "bold",
                        color: COLORS.primary,
                    }}
                >
                    About DebateMindAI
                </h1>
                <p
                    style={{
                        fontSize: "20px",
                        color: COLORS.text_muted,
                        maxWidth: "800px",
                        marginTop: "8px",
                        padding: "20px",
                    }}
                >
                    We're on a mission to democratize knowledge and foster meaningful discussions through AI-powered talk shows that bring together experts, thought leaders, and curious minds from around the world.
                </p>
            </div>

            {/*Vision Mission Section */}
            <div className="vision-mission">
                <div className="mission">
                    <div className="mission-title">
                        <FaBullseye 
                        style={{fontSize:"24px", marginBottom:"5px"}}/>
                        <h2 style={{fontSize:"24px"}}>Our Mission</h2>
                    </div>
                    <div className="mission-des">
                        <p>To create an accessible platform where complex ideas are explored through engaging conversations, making knowledge and insights available to everyone, regardless of their background or location.</p>
                    </div>
                </div>
                <div className="vision">
                    <div className="vision-title">
                        <FaGlobe
                        style={{fontSize:"24px", marginBottom:"5px"}}/>
                        <h2 style={{fontSize:"24px"}}>Our Vision</h2>
                    </div>
                    <div className="vision-des">
                        <p>A world where every person has access to thought-provoking discussions and diverse perspectives, empowering them to make informed decisions and contribute meaningfully to society.</p>
                    </div>
                </div>
            </div>

            {/* Our value */}

            <div className="our-value">
                <div className="value-title">
                    <h3>Our Value</h3>
                </div>
                <div className="value-card-container">
                    <div className="value-card">
                        <FaLightbulb 
                         style={{
                            fontSize:"32px",
                            color: "#FFC403",
                            marginBottom: "8px"
                        }}/>
                        <h4>Innovation</h4>
                        <p>We embrace cutting-edge technology and fresh perspectives to create meaningful discussions.</p>
                    </div>
                    <div className="value-card">
                        <FaRegHeart
                         style={{
                            fontSize:"32px",
                            color: "red",
                            marginBottom: "8px"
                        }}/>
                        <h4>Inclusivity</h4>
                        <p>We believe diverse voices and backgrounds make for richer, more valuable conversations.</p>
                    </div>
                    <div className="value-card">
                        <FaBullseye 
                         style={{
                            fontSize:"32px",
                            color: "#0D6EFD",
                            marginBottom: "8px"
                        }}/>
                        <h4>Quality</h4>
                        <p>We maintain high standards for content, ensuring every show delivers real value.</p>
                    </div>
                    <div className="value-card">
                        <FaBolt
                         style={{
                            fontSize:"32px",
                            color: "#AD46FF",
                            marginBottom: "8px"
                        }}/>
                        <h4>Impact</h4>
                        <p>We aim to create discussions that inspire action and positive change in the world.</p>
                    </div>
                </div>
            </div>

        </div>
    );
}

